import React from 'react';

const IconLogo = () => <img id="logo" className="" alt="Tech tinkerer Logo" src="/logo.png"></img>;
export default IconLogo;
